import React from 'react';
import { NavLink } from 'components/router';

export const contacts = [
  {
    label: 'Scrivici',
    value: <a href="https://servizicrm.comune.milano.it/Wemi/Richiestecomplesse" target="_blank">Invia la tua richiesta online</a>,
  },
  {
    label: 'Chiamaci',
    value: (
      <>
        <a href="tel:020202">020202</a>
        {' '}
        - tasto 4.1
      </>
    ),
  },
  {
    label: 'Incontraci',
    value: (
      <NavLink
        role="menuitem"
        to="/spazi-wemi"
      >
        Scopri gli Spazi WeMi
      </NavLink>
    ),
  },
];
